import Vue from "vue";
import Vuex from "vuex";
import search from "./modules/search";
import overlay from "./modules/overlay";

Vue.use( Vuex );

const debug = process.env.NODE_ENV !== "production";

const modules = {
  search,
  overlay
};

const store = new Vuex.Store( {
  strict: debug,
  modules
} );


const { state } = store;

// Only replace the initial state if something is set
/* eslint-disable no-underscore-dangle */
if ( Object.keys( window.__INITIAL_STATE__ ).length !== 0 ) {
  store.replaceState( Object.assign( {}, state, window.__INITIAL_STATE__ ) );
}
/* eslint-enable no-underscore-dangle */

export { store };
